import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraInput, SpecraText } from '@mono/ui-components/ensigns';
import { SpecraTooltip } from '@mono/ui-components/lieutenants';
import { Testids } from '@mono/ui-selectors';
import { useEffect, useState } from 'react';
export function ParameterField({ param, editable, period, onChange, label = param.label }) {
    const value = period ? param.periodValues?.[period] ?? null : param.value;
    const [text, setText] = useState(value == null ? '' : String(value));
    useEffect(()=>setText(value == null ? '' : String(value)), [
        value
    ]);
    const locked = !editable || param.metadata?.locked || [
        'government',
        'computed',
        'evaluation'
    ].includes(param.source);
    const number = text.trim() ? Number(text) : null;
    const c = param.constraints;
    const invalid = number !== null && (!Number.isFinite(number) || c?.min !== undefined && number < c.min || c?.max !== undefined && number > c.max || c?.nte !== undefined && number > c.nte || c?.noFractions && !Number.isInteger(number));
    const source = `${param.source}${param.metadata?.notes ? ` · ${param.metadata.notes}` : ''}${param.metadata?.sourceDocument ? ` · ${param.metadata.sourceDocument}` : ''}`;
    return /*#__PURE__*/ _jsx(SpecraTooltip, {
        content: source,
        children: locked ? /*#__PURE__*/ _jsxs(SpecraText, {
            tabIndex: 0,
            children: [
                value ?? '—',
                param.paramType === 'percentage' ? ' (fraction)' : ''
            ]
        }) : /*#__PURE__*/ _jsx(SpecraInput, {
            "aria-label": label,
            "data-testid": Testids.pricingWorkspace.parameter,
            inputMode: "decimal",
            value: text,
            invalid: !!invalid,
            onChange: (event)=>{
                const next = event.target.value;
                setText(next);
                const parsed = next.trim() ? Number(next) : null;
                if (parsed !== null && (!Number.isFinite(parsed) || c?.min !== undefined && parsed < c.min || c?.max !== undefined && parsed > c.max || c?.nte !== undefined && parsed > c.nte || c?.noFractions && !Number.isInteger(parsed))) return;
                onChange(parsed);
            }
        })
    });
}
